module.exports = "<button mat-button class=\"button\" (click)=\"openQuickpanel()\" fxFlex=\"grow\">\n  <mat-icon>format_align_right</mat-icon>\n</button>\n"